import React, {Fragment} from 'react';
import getJobUri from '../../../../common/views/helpers/getJobUri';
import ReactDOMServer from 'react-dom/server';

/* eslint-disable complexity */
const Jobs = ({team, filters}) => {
    if (
        !filters.category &&
        (!team.locationCities || !team.locationCities.length)
    ) {
        return null;
    }
    return (
        <Fragment>
            <ul className="list-unstyled" data-filters-search={filters.search}>
                {Array.prototype.concat
                    .apply(
                        [],
                        team.locationCities
                            .filter(
                                (city) =>
                                    !filters.location ||
                                    city.locationCity === filters.location,
                            )
                            .map((city) => city.locations),
                    )
                    .map((location) => (
                        <Fragment key={location.locationId}>
                            <li className="location-city">
                                {location.location}
                            </li>
                            {location.requisitionSummaries
                                .filter(
                                    (summary) =>
                                        !!summary.Job_Requisition ||
                                        !!summary.objectID,
                                )
                                .map((summary) => (
                                    <li key={summary.Job_Requisition}>
                                        <a
                                            className="small"
                                            href={`/careers/job/${getJobUri(
                                                summary.Job_Requisition ||
                                                    summary.objectID,
                                                summary.Job_Title,
                                            )}/`}
                                        >
                                            {summary.Job_Title}
                                        </a>
                                    </li>
                                ))}
                        </Fragment>
                    ))}
            </ul>
            {!filters.category && (
                <h3>
                    <a
                        href={`/careers/openings?category=${team.teamId}`}
                        dangerouslySetInnerHTML={{
                            __html: team.title,
                        }}
                    />
                </h3>
            )}
            {team.description && <p className="small">{team.description}</p>}
        </Fragment>
    );
};

const OpeningsList = ({team, filters}) => {
    // @FIXME
    const fragment = (
        <Fragment>
            {filters.category && (
                <h3
                    dangerouslySetInnerHTML={{
                        __html: team.title,
                    }}
                />
            )}
            <Jobs team={team} filters={filters} />
        </Fragment>
    );
    const html = ReactDOMServer.renderToString(fragment);
    return html && !html.startsWith('<ul class="list-unstyled"></ul>') ? (
        <section
            className="openings-group"
            dangerouslySetInnerHTML={{__html: html}}
        />
    ) : null;
};

export default OpeningsList;
